<template>
  <div>
    <b-row>
      <b-col>
        <h3>Payment Report</h3>
      </b-col>
    </b-row>
    <b-card>
      <b-row>
        <b-col md="9"></b-col>
        <b-col>
          <eb-select
            style="background-color: #fff"
            id="text"
            type="text"
            label="text"
            :options="dateOption1"
            v-model="selectedDate1"
            :selected="selectedDate1.text"
            @input="changeDate1"
          >
          </eb-select>
          <b-modal
            title="Select Date"
            header-class="header-nipige-class"
            id="dateRange1"
            size="sm"
            ref="date-range1"
            centered
            hide-footer
          >
            <b-input class="mb-2" type="date" v-model="startDate1"></b-input>
            <b-input type="date" v-model="endDate1"></b-input>
            <div class="text-center mt-2">
              <b-button
                @click="findButtonClick1()"
                class="my -0 main-navigation-button w-47 mr-2"
                variant="success"
                >Find
              </b-button>
            </div>
          </b-modal></b-col
        ></b-row
      >
      <b-row>
        <b-col md="2">
          <b-card
            style="
              height: 150px;
              border-radius: 10px;
              border-bottom: 5px solid #ffaf37;
            "
          >
            Total Order Amount
            <div class="d-flex justify-content-between mt-2">
              <div class="green-chart-icon">
                <i class="fa fa-line-chart" aria-hidden="true"></i>
              </div>
              <h4 class="ml-2 mt-0 mb-0 order-price-heading">
                रु {{ totalEarning }}
              </h4>
            </div>
          </b-card>
        </b-col>
        <b-col md="2">
          <b-card
            style="
              height: 150px;
              border-radius: 10px;
              border-bottom: 5px solid #ffaf37;
            "
          >
            Total Collected
            <div class="d-flex justify-content-between mt-2">
              <div class="green-chart-icon">
                <i class="fa fa-line-chart" aria-hidden="true"></i>
              </div>
              <h4 class="ml-2 mt-0 mb-0 order-price-heading">
                रु {{ totalCollected }}
              </h4>
            </div>
          </b-card>
        </b-col>
        <b-col md="2">
          <b-card
            style="
              height: 150px;
              border-radius: 10px;
              border-bottom: 5px solid #ffaf37;
            "
          >
            Total Pending Amount
            <div class="d-flex justify-content-between mt-2">
              <div class="green-chart-icon">
                <i class="fa fa-line-chart" aria-hidden="true"></i>
              </div>
              <h4 class="ml-2 mt-0 mb-0 order-price-heading">
                रु {{ totalPendingAmount }}
              </h4>
            </div>
          </b-card>
        </b-col>
        <b-col md="2">
          <b-card
            style="
              height: 150px;
              border-radius: 10px;
              border-bottom: 5px solid #ffaf37;
            "
          >
            Total Refunded
            <div class="d-flex justify-content-between mt-2">
              <div class="green-chart-icon">
                <i class="fa fa-line-chart" aria-hidden="true"></i>
              </div>
              <h4 class="ml-2 mt-0 mb-0 order-price-heading">
                रु {{ totalRefunded }}
              </h4>
            </div>
          </b-card>
        </b-col>
        <b-col md="2">
          <b-card
            style="
              height: 150px;
              border-radius: 10px;
              border-bottom: 5px solid #ffaf37;
            "
          >
            Total Cancelled Order Amount
            <div class="d-flex justify-content-between mt-2">
              <div class="green-chart-icon">
                <i class="fa fa-line-chart" aria-hidden="true"></i>
              </div>
              <h4 class="ml-2 mt-0 mb-0 order-price-heading">
                रु {{ totalFailed }}
              </h4>
            </div>
          </b-card>
        </b-col>
        <b-col md="2">
          <b-card
            style="
              height: 150px;
              border-radius: 10px;
              border-bottom: 5px solid #ffaf37;
            "
          >
            Total Earning this month
            <div class="d-flex justify-content-between mt-2">
              <div class="green-chart-icon">
                <i class="fa fa-line-chart" aria-hidden="true"></i>
              </div>
              <h4 class="ml-2 mt-0 mb-0 order-price-heading">
                रु {{ totalEarningMonth }}
              </h4>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
    <b-card
      ><b-row
        ><b-col md="9"><h4>Payment By Mode</h4></b-col
        ><b-col>
          <eb-select
            style="background-color: #fff"
            id="text"
            type="text"
            label="text"
            :options="dateOption"
            v-model="selectedDate"
            :selected="selectedDate.text"
            @input="changeDate"
          >
          </eb-select>
          <b-modal
            title="Select Date"
            header-class="header-nipige-class"
            id="dateRange"
            size="sm"
            ref="date-range"
            centered
            hide-footer
          >
            <b-input class="mb-2" type="date" v-model="startDate"></b-input>
            <b-input type="date" v-model="endDate"></b-input>
            <div class="text-center mt-2">
              <b-button
                @click="findButtonClick()"
                class="my -0 main-navigation-button w-47 mr-2"
                variant="success"
                >Find
              </b-button>
            </div>
          </b-modal>
        </b-col></b-row
      >
      <BarChart :chart-data="chartData" :chart-options="barChartOptions" />
    </b-card>
  </div>
</template>
<script>
import ComponentHeader from "@/components/componentHeader";
import moment from "moment";
import ebSelect from "@/components/FormElements/Select.vue";
import BarChart from "@/components/chart/BarChart";
import paymentChart from "@/utils/paymentChart";
export default {
  name: "Reports",
  components: {
    ComponentHeader,
    ebSelect,
    BarChart,
  },
  data() {
    return {
      totalCollected: 0,
      totalEarning: 0,
      totalEarningMonth: 0,
      totalFailed: 0,
      totalRefunded: 0,
      totalPendingAmount: 0,
      selectedDate: {
        text: "Today",
        value: 1,
      },
      dateOption: [
        {
          text: "Today",
          value: 1,
        },
        {
          text: "7 day's",
          value: 7,
        },
        {
          text: "30 day's",
          value: 30,
        },
        {
          text: "Custom",
          value: "custom",
        },
      ],
      startDate: "",
      endDate: "",

      selectedDate1: {
        text: "Today",
        value: 1,
      },
      dateOption1: [
        {
          text: "Today",
          value: 1,
        },
        {
          text: "7 day's",
          value: 7,
        },
        {
          text: "30 day's",
          value: 30,
        },
        {
          text: "Custom",
          value: "custom",
        },
      ],
      startDate1: "",
      endDate1: "",
      barChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true,
          },
        },
      },
    };
  },
  computed: {
    userId() {
      if (this.$store.getters["auth/getUserID"]) {
        return this.$store.getters["auth/getUserID"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
      }
    },
    chartData() {
      let data = this.$store.getters["partner/getChartData"];
      let paymentkey = "";
      let paymentMode = "";
      let paymentAmount = "";
      let date = "";
      if (this.$currentUserData.category == "TA") {
        paymentkey = "orderbypaymenttype-graph";
        paymentAmount = "count";
        paymentMode = "payment";
        date = "date";
      } else if (this.$currentUserData.category === "SELLER") {
        paymentkey = "seller-orderbypaymenttype-graph";
        paymentAmount = "ordercount";
        date = "date";
        paymentMode = "paymenttype";
      } else if (
        this.$currentUserData.category === "DISTRIBUTOR" ||
        this.$currentUserData.category === "DEALER" ||
        this.$currentUserData.category === "SUB_DEALER"
      ) {
        paymentkey = "subdealer-orderbypaymenttype-graph";
        paymentAmount = "ordercount";
        date = "date";
        paymentMode = "paymenttype";
      }
      const paymentList = data[paymentkey];
      return paymentChart(paymentList, paymentAmount, date, paymentMode);
    },
  },
  methods: {
    findButtonClick1() {
      let e = {
        fromDate: this.startDate1,
        toDate: this.endDate1,
      };
      this.$refs["date-range1"].hide();
      this.dashboardReport();
    },
    changeDate1(e) {
      this.selectedDate1 = e;
      if (e.value == "custom") {
        this.$refs["date-range1"].show();
        return;
      }
      this.dashboardReport();
    },
    getDateData1(dateData) {
      if (dateData == "custom") {
        const data = {
          fromDate: this.startDate1,
          toDate: this.endDate1,
        };
        return data;
      }
      if (dateData == 1) {
        const data = {
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().add(1, "days").format("YYYY-MM-DD"),
        };
        return data;
      } else {
        const data = {
          fromDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        if (typeof dateData === "number") {
          data.fromDate = moment()
            .subtract(dateData, "days")
            .format("YYYY-MM-DD");
          return data;
        } else if (typeof dateData === "object") {
          return dateData;
        }
        return data;
      }
    },
    async dashboardReport() {
      if (this.$currentUserData.category === "TA") {
        const payload = {
          items: [
            {
              key: "total-collected",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                tenant: this.userId,
              },
            },
            {
              key: "total-pending-collection",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                tenant: this.userId,
              },
            },
            {
              key: "total-refunded",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                tenant: this.userId,
              },
            },
            {
              key: "total-payment-cancelled",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                tenant: this.userId,
              },
            },
            {
              key: "total-orders",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                tenant: this.userId,
              },
            },
          ],
        };
        const data = await this.$store.dispatch(
          "partner/fetchBulkAnalyticReport",
          payload
        );
        this.totalCollected = data["total-collected"].totalcollected || 0;
        this.totalEarning = +data["total-orders"]?.total_order_amount || 0;
        this.totalFailed = data["total-payment-cancelled"].total_collected || 0;
        this.totalRefunded = data["total-refunded"].total_collected || 0;
        this.totalPendingAmount =
          data["total-pending-collection"].total_collected || 0;
        const payload1 = {
          items: [
            {
              key: "total-orders",
              variables: {
                fromDate: this.getProperDate1(
                  moment().startOf("month").toISOString()
                ),
                toDate: this.getProperDate1(
                  moment()
                    .add(+1, "days")
                    .toDate()
                    .toISOString()
                ),
                tenant: this.userId,
              },
            },
          ],
        };
        const data1 = await this.$store.dispatch(
          "partner/fetchBulkAnalyticReport",
          payload1
        );
        this.totalEarningMonth = (
          +data1["total-orders"]?.total_order_amount || 0
        ).toFixed(2);
      } else if (this.$currentUserData.category === "SELLER") {
        const payload = {
          items: [
            {
              key: "seller-total-orders",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "seller-total-collected",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "seller-pending-collection",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "seller-total-refunded",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "seller-total-payment-cancelled",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
          ],
        };
        const data = await this.$store.dispatch(
          "partner/fetchBulkAnalyticReport",
          payload
        );
        this.totalCollected =
          data["seller-total-collected"].totalcollected || 0;
        this.totalEarning = (
          +data["seller-total-orders"]?.total_order_amount || 0
        ).toFixed(2);
        this.totalFailed =
          data["seller-total-payment-cancelled"].total_collected || 0;
        this.totalRefunded = data["seller-total-refunded"].total_collected || 0;
        this.totalPendingAmount =
          data["seller-pending-collection"].total_collected || 0;
        const payload1 = {
          items: [
            {
              key: "seller-total-orders",
              variables: {
                fromDate: this.getProperDate1(
                  moment().startOf("month").toISOString()
                ),
                toDate: this.getProperDate1(
                  moment()
                    .add(+1, "days")
                    .toDate()
                    .toISOString()
                ),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
          ],
        };
        const data1 = await this.$store.dispatch(
          "partner/fetchBulkAnalyticReport",
          payload1
        );
        this.totalEarningMonth = (
          +data1["seller-total-orders"].total_order_amount || 0
        ).toFixed(2);
      } else if (
        this.$currentUserData.category === "DISTRIBUTOR" ||
        this.$currentUserData.category === "DEALER" ||
        this.$currentUserData.category === "SUB_DEALER"
      ) {
        const payload = {
          items: [
            {
              key: "subdealer-total-orders",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "subdealer-total-collected",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "subdealer-pending-collection",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "subdealer-total-refunded",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "subdealer-total-payment-cancelled",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
          ],
        };
        const data = await this.$store.dispatch(
          "partner/fetchBulkAnalyticReport",
          payload
        );
        this.totalCollected =
          data["subdealer-total-collected"].total_collected || 0;
        this.totalEarning = (
          +data["subdealer-total-orders"].total_order_amount || 0
        ).toFixed(2);
        this.totalFailed =
          data["subdealer-total-payment-cancelled"].total_collected || 0;
        this.totalRefunded =
          data["subdealer-total-refunded"].total_collected || 0;
        this.totalPendingAmount =
          data["subdealer-pending-collection"].total_collected || 0;
        const payload1 = {
          items: [
            {
              key: "subdealer-total-orders",
              variables: {
                fromDate: this.getProperDate1(
                  moment().startOf("month").toISOString()
                ),
                toDate: this.getProperDate1(
                  moment()
                    .add(+1, "days")
                    .toDate()
                    .toISOString()
                ),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
          ],
        };
        const data1 = await this.$store.dispatch(
          "partner/fetchBulkAnalyticReport",
          payload1
        );
        this.totalEarningMonth = (
          +data1["subdealer-total-orders"]?.total_order_amount || 0
        ).toFixed(2);
      }
    },
    getProperDate1(data) {
      if (data != null) {
        let date = new Date(data);
        return moment(String(date)).format("YYYY-MM-DD");
      } else return "Unavailable";
    },
    findButtonClick() {
      let e = {
        fromDate: this.startDate,
        toDate: this.endDate,
      };
      this.$refs["date-range"].hide();
      this.fetchPaymentChart();
    },
    changeDate(e) {
      this.selectedDate = e;
      if (e.value == "custom") {
        this.$refs["date-range"].show();
        return;
      }
      this.fetchPaymentChart();
    },
    getDateData(dateData) {
      if (dateData == "custom") {
        const data = {
          fromDate: this.startDate,
          toDate: this.endDate,
        };
        return data;
      }
      if (dateData == 1) {
        const data = {
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().add(1, "days").format("YYYY-MM-DD"),
        };
        return data;
      } else {
        const data = {
          fromDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        if (typeof dateData === "number") {
          data.fromDate = moment()
            .subtract(dateData, "days")
            .format("YYYY-MM-DD");
          return data;
        } else if (typeof dateData === "object") {
          return dateData;
        }
        return data;
      }
    },
    async fetchPaymentChart() {
      if (this.$currentUserData.category === "TA") {
        const payload = {
          items: [
            {
              key: "orderbypaymenttype-graph",
              variables: {
                ...this.getDateData(this.selectedDate.value),
                tenant: this.userId,
              },
            },
          ],
        };
        await this.$store.dispatch("partner/fetchChart", payload);
      } else if (this.$currentUserData.category === "SELLER") {
        const payload = {
          items: [
            {
              key: "seller-orderbypaymenttype-graph",
              variables: {
                ...this.getDateData(this.selectedDate.value),
                tenant: this.$currentUserData.tenant,
                userId: this.userId,
              },
            },
          ],
        };
        await this.$store.dispatch("partner/fetchChart", payload);
      } else if (
        this.$currentUserData.category === "DISTRIBUTOR" ||
        this.$currentUserData.category === "DEALER" ||
        this.$currentUserData.category === "SUB_DEALER"
      ) {
        const payload = {
          items: [
            {
              key: "subdealer-orderbypaymenttype-graph",
              variables: {
                ...this.getDateData(this.selectedDate.value),
                tenant: this.$currentUserData.tenant,
                userId: this.userId,
              },
            },
          ],
        };
        await this.$store.dispatch("partner/fetchChart", payload);
      }
    },
  },
  mounted() {
    this.dashboardReport();
    this.fetchPaymentChart();
  },
};
</script>
<style scoped>
.green-chart-icon i {
  background: #def6ee;
  text-align: center;
  color: #65d27d;
  border-radius: 5px;
  font-size: 16px !important;
  height: 36px;
  width: 36px;
  line-height: 36px;
}
.order-price-heading {
  line-break: anywhere;
  line-height: 24px;
}
</style>

